var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    {
      attrs: {
        title: "Logs",
        subTitle:
          "Os resultados serão limitados ao que for encontrado apenas nos últimos 10 dias. Para buscas utilizando um id de cotação, será exibido o resultado encontrado dentro dos últimos 30 dias."
      }
    },
    [
      _c("div", { staticClass: "box" }, [_c("sc-logs-api-filters")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "sc-tabs",
            [
              _c(
                "sc-tab-item",
                { attrs: { label: "Últimas 10 chamadas" } },
                [_c("sc-logs-api-list-all")],
                1
              ),
              _vm._v(" "),
              _c(
                "sc-tab-item",
                { attrs: { label: "Últimas 10 chamadas com erros" } },
                [_c("sc-logs-api-list-errors")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-595f8217", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-595f8217","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/PageLogsApi.vue
// module id = null
// module chunks = 